import { writable } from 'svelte/store';

export const globalToastMessage = writable<string | null>(null);

export const showGlobalToast = (message: string) => {
    globalToastMessage.set(message);
};
